import { useCallback } from 'react';

const useHandleSetMessage = (setMessages) => {
    return useCallback((message, tag) => {
        setMessages((prevMessages) => [...prevMessages, { text: message, tag }]);
    }, [setMessages]);
};

export default useHandleSetMessage;

